import {setContext} from './context';
import {trackEvent} from './eventTracker';
import {v4 as uuidv4} from 'uuid';

let inactivityTimer: NodeJS.Timeout;

export const startSession = () => {
    const sessionId = uuidv4();
    setContext({session_id: sessionId});

    trackEvent('Session Start');
    resetInactivityTimer();
};

export const endSession = (reason = 'inactivity') => {
    trackEvent('Session End', {reason});
    setContext({session_id: null}); // 종료 후 제거
    clearTimeout(inactivityTimer);
};

export const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => endSession('inactivity'), 60 * 60 * 1000);
};

export const initSessionHandlers = () => {
    const alreadyStarted = !!localStorage.getItem('session_started');
    if (!alreadyStarted) {
        startSession();
        localStorage.setItem('session_started', 'true');
    }

    ['click', 'mousemove', 'keydown'].forEach((evt) => {
        window.addEventListener(evt, resetInactivityTimer);
    });

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            resetInactivityTimer();
        }
    });
};

export const handleLogout = () => {
    endSession('logout');
    localStorage.removeItem('session_started');
};
